import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { StarField } from './components/StarField';
import { trackPageView } from './utils/pixel';
export function App() {
  useEffect(() => {
    trackPageView();
  }, []);
  return <div className="relative w-full min-h-screen bg-night-900" data-id="element-0">
      <StarField data-id="element-1" />
      <LandingPage data-id="element-2" />
    </div>;
}